export enum AiTemplates {
    ImproveWriting = "ImproveWriting",
    ImproveSpelling = "ImproveSpelling",
    ContinueWriting = "ContinueWriting",
    Summarize = "Summarize",
    SummarizeBulletPoints = "SummarizeBulletPoints",
    ChangeTone = "ChangeTone",
}

export enum AiTones {
    Formal = "formal",
    Friendly = "friendly",
    Professional = "professional",
    Straightforward = "straightforward",
    Optimistic = "optimistic",
}

export const AiSuggestionBlockName = "AiSuggestion";

export type AiSuggestionContext = {
    prompt: string;
    template: AiTemplates;
    tone?: AiTones;
};

export type AiCompletionState = {
    /** Server answer */
    suggestion: string;
    context: AiSuggestionContext;
};
